import { useEffect } from 'react'

interface UseScrollToRowProps {
  scrollPosition: string | null
  tableRows: any[]
  highlightColor?: string
  highlightDuration?: number
}

const useScrollToRow = ({
  scrollPosition,
  tableRows,
  highlightColor = '#ECE9F2',
  highlightDuration = 2000,
}: UseScrollToRowProps) => {
  useEffect(() => {
    if (scrollPosition && tableRows?.length > 0) {
      const row = document.getElementById(scrollPosition)
      if (row) {
        row.style.backgroundColor = highlightColor
        row?.scrollIntoView({ behavior: 'smooth', block: 'center' })

        const timer = setTimeout(() => {
          row.style.backgroundColor = 'transparent'
        }, highlightDuration)

        return () => clearTimeout(timer)
      }
    }
  }, [tableRows])
}

export default useScrollToRow
